export default {
  visual: {
    subtitle: 'Our Vision',
    title: 'Hiện thực hóa một thế giới ảo<br/>đầy sinh động.',
    description:
      'Orbro được phát triển nhằm mục đích trực quan hóa khoảng 200 Zettabyte dữ liệu đang tồn tại trên toàn cầu. Hướng tới một hệ sinh thái dữ liệu bền vững, chúng tôi sao chép thông tin toàn cầu vào Orbro và kiến tạo những liên kết dữ liệu đột phá thông qua các đối tượng được mô hình hóa 3D. <br/><br/> Trên nền tảng Orbro, dữ liệu vị trí thu thập từ các sản phẩm chuyên biệt và thông tin phân tán trực tuyến được liên kết với nhau, cho phép hơn 20.000 đối tượng chuyển động theo thời gian thực. Để đẩy nhanh tốc độ này, chúng tôi đang kiến tạo một hệ sinh thái mở, nơi mọi người từ khắp nơi trên thế giới có thể tham gia thông qua các chính sách mở minh bạch. <br/><br/> Hãy xây dựng thế giới của riêng bạn trên Orbro và cùng tham gia vào hành trình chuyển đổi số.',
    items: [
      { title: 'Đầu tiên trên thế giới', description: 'Nền tảng thế giới ảo dựa trên Web' },
      { title: 'Lớn nhất thế giới', description: 'Nền tảng kết nối thông tin giữa thế giới thực và thế giới ảo' },
      { title: 'Hơn 50 tỷ', description: 'Dữ liệu thông tin vị trí đã được phân tích với quy mô lớn nhất châu Á' },
      { title: 'Đứng thứ nhất', description: 'Thành tích Metaverse công nghiệp<br/>(theo tiêu chuẩn tại Hàn Quốc)' },
      { title: 'Hơn 150,000', description: 'Lượng sản phẩm Orbro đã bán' },
      { title: 'Hơn 500,000', description: 'Tổng số người dùng dịch vụ tích lũy' },
      { title: 'Hơn 20,000', description: 'Số lượng đối tượng thời gian thực kết nối với Orbro' },
      { title: '97.5%', description: 'Tổng số tòa nhà trên toàn cầu đã được tải lên' },
      { title: 'Hơn 1,000', description: 'Số lượng khách hàng tích lũy' },
    ],
  },
  ourPartners: {
    subtitle: 'Our Partners',
    title: 'Nhiều doanh nghiệp đang trải nghiệm <br/> chuyển đổi số cùng Orbro.',
  },
  ourTechnology: {
    subtitle: 'Our Technology',
    title: 'Orbro <br/> đổi mới công nghệ.',
    description: 'Qua nhiều năm nghiên cứu, Orbro đã sở hữu các công nghệ cốt lõi trong lĩnh vực phân tích vị trí.',
    policy: 'Các bằng sáng chế liên quan',
    items: [
      {
        title: 'Ổn định tín hiệu vô tuyến',
        description:
          'Tín hiệu 2.4GHz thường gặp khó khăn trong việc sử dụng do ảnh hưởng từ môi trường xung quanh. Vì lý do này, công nghệ ổn định tín hiệu vô tuyến là yếu tố thiết yếu trong các hệ thống sử dụng beacon. Công nghệ xử lý tín hiệu vô tuyến của Orbro đã được kiểm chứng qua khoảng 10 năm tại hơn 300 địa điểm thực tế và được thiết kế để có thể điều chỉnh nhanh chóng theo các yêu cầu cụ thể của khách hàng.',
        policy: [
          'Hệ thống, phương pháp và phương tiện đọc được bằng máy tính để xác định vị trí của thẻ di động dựa trên tín hiệu vô tuyến',
          'Hệ thống beacon di động báo cáo tình huống nguy hiểm của người dùng tới máy chủ giám sát',
        ],
      },
      {
        title: 'Thiết kế anten định hướng',
        description:
          'Tín hiệu Bluetooth dễ bị ảnh hưởng bởi môi trường xung quanh, do đó việc thiết kế anten phù hợp với điều kiện môi trường là yếu tố cơ bản nhất trong công nghệ truyền thông vô tuyến. Không chỉ có anten vô hướng, chúng tôi còn có khả năng thiết kế anten định hướng, cho phép phân biệt hướng của tín hiệu. Kết quả là, bằng cách tích hợp anten, sản phẩm và hệ thống xử lý tín hiệu thành một gói giải pháp duy nhất, Orbro có thể cung cấp dịch vụ ổn định và hiệu quả hơn.',
        policy: ['Phương pháp và hệ thống kiểm soát cửa dựa trên tín hiệu beacon'],
      },
      {
        title: 'Phân tách tín hiệu / Xử lý đa tín hiệu',
        description:
          'Bằng cách sử dụng nhiều anten, chúng tôi có thể truyền và nhận tín hiệu nhanh hơn, đồng thời xác định được thiết bị di động (hoặc điện thoại) đang ở gần tín hiệu nào. Việc ứng dụng công nghệ xử lý đa tín hiệu cho phép phân biệt bên trong và bên ngoài cửa, hoặc sự ra vào của một tòa nhà, từ đó tạo ra các ứng dụng dịch vụ mới.',
        policy: [
          'Hệ thống, phương pháp và phương tiện đọc được bằng máy tính để xác định vị trí của thẻ di động dựa trên tín hiệu vô tuyến',
          'Hệ thống cung cấp thông tin cho các thiết bị điện tử trong cửa hàng kèm theo chức năng bảo mật',
        ],
      },
      {
        title: 'Kích hoạt vô tuyến công suất thấp',
        description:
          'Công nghệ kích hoạt vô tuyến công suất thấp cho phép thiết bị đầu cuối, vốn cần truyền tín hiệu trong thời gian dài với mức năng lượng thấp, nhận tín hiệu kích hoạt từ bộ thu để tạm thời thực hiện giao tiếp hai chiều. So với phương pháp ghép nối (pairing) để trao đổi dữ liệu, công nghệ này nhanh hơn khoảng 10 lần và tiêu thụ năng lượng thấp hơn hơn 20 lần.',
        policy: ['Phương pháp và hệ thống phát hiện tín hiệu của thiết bị beacon'],
      },
      {
        title: 'Mạng lưới Mesh',
        description:
          'Mạng lưới Mesh của Orbro tạo ra kết quả hiệu quả hơn trong các môi trường yêu cầu giao tiếp công suất thấp. Hoạt động dựa trên thuật toán Flooding Mesh và công nghệ kích hoạt vô tuyến công suất thấp, mạng lưới này tiêu thụ điện năng thấp hơn đến 50 lần so với các beacon thông thường, đồng thời hoạt động nhanh hơn gấp 3 lần và hỗ trợ kết nối đa thông tin. Công nghệ này đặc biệt hiệu quả khi cần thu nhận thông tin định kỳ từ nhiều thiết bị trong môi trường thiếu ổn định về nguồn điện.',
        policy: ['Phương pháp triển khai mạng lưới Mesh trong hệ thống beacon', 'Hệ thống chuông báo an toàn sử dụng công nghệ truyền thông mạng lưới Mesh'],
      },
      {
        title: 'Công nghệ định vị tín hiệu vô hướng',
        description:
          'Insight của Orbro phân tích mối quan hệ giữa các Twintracker được lắp đặt và thiết bị đầu cuối của người dùng để suy ra vector hướng của Tag đối với từng Twintracker. Về mặt lý thuyết, điểm giao nhau của các vector được suy ra có thể xác định hướng của Tag. Tuy nhiên, trong môi trường thực tế, sự bất ổn của tín hiệu và các chướng ngại vật vật lý khiến các điểm giao nhau không hội tụ tại một vị trí duy nhất. Trong những môi trường như vậy, để xác định vị trí hai chiều, Orbro sử dụng phương pháp suy ra vị trí dựa trên mật độ xác suất trên bản đồ hai chiều.',
        policy: ['Phương pháp và hệ thống xác định vị trí hai chiều của thiết bị đầu cuối người dùng'],
      },
      {
        title: 'Trích xuất tọa độ của đối tượng trong hình ảnh',
        description:
          'Bằng cách áp dụng các công nghệ Phát hiện Đối tượng (Object Detection) và Ước lượng Độ sâu (Depth Estimation), hệ thống có thể nhận diện người trong hình ảnh và suy ra khoảng cách đến người đó. Dựa trên thông tin này, để xác định vị trí của người trên bản đồ hai chiều, hệ thống sử dụng góc nhìn của camera và thông tin pixel để nhận biết hướng của người được phát hiện, từ đó tính toán tọa độ.',
        policy: ['Phương pháp và hệ thống xác định vị trí đối tượng bằng hình ảnh camera'],
      },
      {
        title: 'Thuật toán hậu xử lý phân tích vị trí',
        description:
          'Bằng cách áp dụng các công nghệ Phát hiện Đối tượng (Object Detection) và Ước lượng Độ sâu (Depth Estimation), hệ thống có thể nhận diện người trong hình ảnh và suy ra tọa độ dựa trên khoảng cách và góc độ đến người đó. Để tinh chỉnh kết quả này, hệ thống sử dụng tỷ lệ giữa khoảng cách từ camera đến mặt sàn khi không có người trong không gian và khoảng cách khi có người hiện diện, từ đó dự đoán và điều chỉnh tọa độ của người được nhận diện, đồng thời bổ sung độ chính xác cho kết quả đo lường tọa độ.',
        policy: ['Phương pháp và hệ thống tinh chỉnh dữ liệu vị trí đối tượng bằng hình ảnh camera'],
      },
      {
        title: 'Điều khiển bằng học máy Machine learning',
        description:
          'Sử dụng mô hình học tăng cường 3C, hệ thống áp dụng cơ chế phạt khi người dùng điều chỉnh nhiệt độ và thưởng khi người dùng không điều chỉnh nhiệt độ trong một khoảng thời gian nhất định, từ đó tự động điều khiển để duy trì nhiệt độ phù hợp.',
        policy: [
          'Phương pháp, hệ thống và phương tiện đọc được bằng máy tính để tự động điều khiển điều hòa không khí theo hướng tối ưu hóa sự thoải mái bằng mô hình học máy',
          'Hệ thống, phương pháp và phương tiện đọc được bằng máy tính để điều khiển nhiều điều hòa không khí trong một không gian',
        ],
      },
      {
        title: 'Giao diện bản sao kỹ thuật số',
        description:
          'Orbro sở hữu cấu trúc giao diện được tối ưu hóa cho bản sao kỹ thuật số (digital twin). Người dùng có thể nhấp vào các đối tượng trong không gian 3D để dễ dàng truy cập các ứng dụng liên quan..',
        policy: [
          'Phương pháp cung cấp giao diện thực thi ứng dụng tập trung vào đối tượng, máy chủ dịch vụ thực hiện phương pháp này và phương tiện đọc được bằng máy tính',
          'Phương pháp cung cấp giao diện danh sách ứng dụng liên quan đến đối tượng, máy chủ dịch vụ thực hiện phương pháp này và phương tiện đọc được bằng máy tính',
          'Phương pháp cung cấp giao diện danh sách ứng dụng dựa trên mức độ liên quan giữa đối tượng và ứng dụng, máy chủ dịch vụ thực hiện phương pháp này và phương tiện đọc được bằng máy tính',
        ],
      },
    ],
  },
  ourCulture: {
    subtitle: 'Our Culture',
    title: 'Tại Orbro <br/>chúng tôi làm việc như thế này.',
    description: 'Hành trình biến trí tưởng tượng thành hiện thực giàu giá trị',
    discovery: {
      title: 'Discovery',
      description: 'Khám phá cơ hội trong một thế giới với vô vàn tiềm năng.',
    },
    extension: {
      title: 'Extension',
      description: 'Mở rộng tư duy thông qua sự tập trung và nghiền ngẫm chuyên sâu.',
    },
    collaboration: {
      title: 'Collaboration',
      description: 'Hiện thực hóa trí tưởng tượng thông qua sự hợp tác chặt chẽ.',
    },
    refine: {
      title: 'Refine',
      description: 'Kiến tạo và hoàn thiện những thành quả giàu giá trị.',
    },
  },
  ourHistory: {
    subtitle: 'Our History',
    title: 'Câu chuyện Orbro',
    histories: {
      '2022': [
        'Đạt doanh thu 10 tỷ Won Hàn Quốc sau 7 năm thành lập',
        "Kong tech giành giải thưởng thiết kế 'Red Dot', một trong ba giải thưởng thiết kế hàng đầu thế giới",
        'Ra mắt ‘Orbro’ – nền tảng Metaverse dựa trên công nghệ Digital Twin',
        'Triển khai hệ thống Orbro tại Pangyo, tỉnh Gyeonggi, Hàn Quốc',
      ],
      '2021': [
        'Doanh thu tăng gấp 3 lần so với năm trước, mở rộng văn phòng tại Pangyo',
        'Khởi động dự án “Robot thu gom và xử lý rác thải y tế không tiếp xúc” phối hợp cùng Bộ Môi trường, Woogene B&G, LG Electronics và Đại học Ajou',
        "Trúng thầu dự án 'Xây dựng Nền tảng thử nghiệm (Testbed) công nghệ AI' của Bộ Khoa học và Công nghệ Thông tin Truyền thông Hàn Quốc, đồng thời điều hành ban dự án",
        "Đảm nhận dự án 'Triển khai Hệ thống dự đoán rủi ro tại công trường xây dựng dựa trên AI' cho Tổng công ty Đường cao tốc Hàn Quốc",
      ],
      '2020': [
        'Tích hợp công nghệ phân tích vị trí AI hàng đầu thế giới, chính thức đẩy mạnh cung cấp Kong Service - Hệ thống theo dõi vị trí thời gian thực (RTLS)',
        'Số lượng doanh nghiệp sử dụng Kong Check tăng hơn 10 lần so với năm trước',
        "Trúng thầu dự án 'Hỗ trợ phát triển công nghệ giải quyết các vấn đề an toàn và thiên tai phù hợp theo từng khu vực' của Bộ Hành chính và An toàn Hàn Quốc, cung cấp giải pháp Gyeonggi Ansimbel (Chuông An toàn Gyeonggi)",
      ],
      '2019': [
        'Ra mắt dịch vụ Kong Check (lọt vào Top 3 ngành sau 3 tháng), vượt mốc 10.000 người dùng trả phí.',
        'Tham gia chương trình Vendor Briefing của Gartner.',
      ],
      '2018': [
        'Bắt đầu phân phối toàn cầu công cụ hiệu chuẩn (Calibration Tool) cho nhà máy thông minh',
        'Bắt đầu cung cấp hệ thống quản lý ra vào IoT cho các tập đoàn xây dựng chung cư quy mô lớn tại Hàn Quốc',
      ],
      '2017': ['Ra mắt dịch vụ giám sát Kong Monitoring, lắp đặt trên toàn bộ khu vực sườn dốc nguy hiểm tại đường cao tốc trong nước (khoảng 2.000 điểm)'],
    },
  },
  news: {
    subtitle: 'News',
    title: 'ORBRO trên tin tức',
    news: [
      {
        agency: '매일경제',
        createdAt: '2022.6.27',
        title: 'KongTech giành giải “Red Dot”, một trong ba giải thiết kế hàng đầu thế giới',
        link: 'https://www.mk.co.kr/news/business/view/2022/06/562542/',
      },
      {
        agency: '매일경제',
        createdAt: '2022.4.19',
        title: '"Hiện thực hóa dữ liệu thế giới thực trong metaverse"… KongTech đạt doanh thu 100 tỷ KRW sau 7 năm',
        link: 'https://www.mk.co.kr/news/business/view/2022/04/349210/',
      },
      {
        agency: '이투데이',
        createdAt: '2022.4.18',
        title: 'KongTech vượt mốc doanh thu 100 tỷ KRW… Mua trụ sở Pangyo trị giá 17 tỷ KRW',
        link: 'https://www.etoday.co.kr/news/view/2125046',
      },
      {
        agency: '데이터넷',
        createdAt: '2021.10.29',
        title: 'KongTech hỗ trợ công nghệ IoT tiên tiến cho SK Shieldus và Junglim Architecture',
        link: 'http://www.datanet.co.kr/news/articleView.html?idxno=165926',
      },
      {
        agency: '파이넨셜뉴스',
        createdAt: '2021.10.14',
        title: 'CEO Lee Hak‑kyung của KongTech: "Không có phép màu trong kinh doanh, chỉ có quá trình nỗ lực không ngừng"',
        link: 'http://www.jjan.kr/2118721',
      },
      {
        agency: '지디넷코리아',
        createdAt: '2021.6.24',
        title: 'KongTech: "Chỉ cần smartphone là mở cửa chung cư dễ dàng"',
        link: 'https://zdnet.co.kr/view/?no=20210624211558',
      },
      {
        agency: 'CCTV뉴스',
        createdAt: '2021.6.24',
        title: 'KongTech ra mắt giải pháp bảo mật ra vào chung cư “KongPass” dựa trên smartphone',
        link: 'http://www.cctvnews.co.kr/news/articleView.html?idxno=228019',
      },
      {
        agency: '리크루트타임스',
        createdAt: '2021.5.27',
        title: 'KongTech đồng phát triển robot thu gom rác thải y tế không tiếp xúc',
        link: 'https://www.medipana.com/article/view.php?news_idx=276992&sch_menu=1&sch_gubun=5',
      },
      {
        agency: '데이터넷',
        createdAt: '2020.11.16',
        title: 'KongTech chính thức cung cấp hệ thống định vị thời gian thực “Kong Service”',
        link: 'http://www.datanet.co.kr/news/articleView.html?idxno=152892',
      },
      {
        agency: '글로벌이코노믹',
        createdAt: '2020.2.31',
        title: 'KongTech cập nhật “Kong Check 3.0” – giải pháp quản lý chấm công đáp ứng nhu cầu thực tế',
        link: 'https://news.g-enews.com/ko-kr/news/article/news_all/202002211426069349aca1a8c21a_1/article.html?md=20200221142829_U',
      },
      {
        agency: '시민일보',
        createdAt: '2020.2.5',
        title: 'KongTech cung cấp 250.000 beacon cho dự án điểm danh điện tử nhà trẻ',
        link: 'http://www.siminilbo.co.kr/news/newsview.php?ncode=1065603668995186',
      },
      {
        agency: '시사매거진',
        createdAt: '2019.12.19',
        title: 'KongTech được công nhận doanh nghiệp thân thiện gia đình 2019 bởi Bộ Bình đẳng Giới',
        link: 'https://www.sisamagazine.co.kr/news/articleView.html?idxno=307188',
      },
      {
        agency: '시사뉴스',
        createdAt: '2019.12.3',
        title: 'Kong Check đạt hạng 1 “Mức độ hài lòng thương hiệu Hàn Quốc 2019 – lĩnh vực IT”',
        link: 'http://www.sisa-news.com/news/article.html?no=122374',
      },
      {
        agency: '매거진한경',
        createdAt: '2019.11.26',
        title: 'Kong Check – hệ thống quản lý chấm công thông minh với công nghệ tiên tiến',
        link: 'https://magazine.hankyung.com/business/article/201911262429b',
      },
      {
        agency: '시사매거진',
        createdAt: '2019.7.30',
        title: 'CEO Lee Hak‑kyung của KongTech dẫn đầu công nghệ beacon',
        link: 'https://www.sisamagazine.co.kr/news/articleView.html?idxno=215613',
      },
      {
        agency: '공감신문',
        createdAt: '2018.12.19',
        title: 'Ra mắt “Kong Check” – chương trình quản lý chấm công thông minh không cần thẻ hoặc vân tay',
        link: 'https://www.gokorea.kr/news/articleView.html?idxno=62896',
      },
      {
        agency: '동아닷컴',
        createdAt: '2018.7.27',
        title: 'KongTech sẽ ra mắt hệ thống quản lý an toàn xe buýt mẫu giáo dựa trên beacon vào tháng 9',
        link: 'https://www.donga.com/news/article/all/20180727/91250851/2',
      },
      {
        agency: '에너지경제신문',
        createdAt: '2017.4.21',
        title: 'Đối tác Samsung ARTIK – KongTech ra mắt bo mạch phát triển ARTIK5 Standard EVAL',
        link: 'https://www.ekn.kr/web/view.php?key=282853',
      },
      {
        agency: '데이터넷',
        createdAt: '2017.4.18',
        title: 'Doanh nghiệp IT KongTech chuyển trụ sở tới Pangyo – cú hích tăng trưởng',
        link: 'http://www.datanet.co.kr/news/articleView.html?idxno=110048',
      },
    ],
  },
};
